import type { SVGProps } from 'react';

const SvgForbiddenCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
    <path fill={props.color} fillRule="evenodd" d="M10 0.4C4.73 0.4 0.4 4.73 0.4 10s4.33 9.6 9.6 9.6 9.6-4.33 9.6-9.6S15.27 0.4 10 0.4ZM4.488 14.332c.367.473 .794.9 1.267 1.267l8.577-8.577a7.233 7.233 0 0 0-1.267-1.267L4.488 14.332Z" clipRule="evenodd" />
  </svg>
);

export default SvgForbiddenCircle;